<template>
    <div class="backChart">
        <div class="backChart_back"
             :style="{
            background:`url('${configImgUrl()}${backGroundList[back.index].img}')`,
            }"></div>
        <div class="backChart_modal" :style="{
            backgroundColor:back.modalBackColor,
            }"></div>
    </div>
</template>

<script>
    import {backList} from '../script/comChart'

    /**
     @author xiaoye
     @date 2020/5/25 2:15 下午
     */
    export default {
        name: 'backChart',
        components: {},
        props: {
            back: {
                type: Object,
                default: {}
            },
        },
        data() {
            return {
                //背景
                backGroundList: backList
            }
        },
        methods: {},
        mounted() {

        },
        destroyed() {

        }
    }
</script>

<style lang="less">
    .backChart {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;

        .backChart_back {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            background-size: 100% 100% !important;
        }

        .backChart_modal {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
        }
    }
</style>
